import { LoadingOverlay, Title } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { type ReactNode } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import ActionButton from "../buttons/ActionButton";

export interface Props {
  title: ReactNode;
  navRightSection?: ReactNode;
  children: ReactNode;
  loading?: boolean;
  /** Fixed destination for the back button. Without it the button walks browser history. */
  backTo?: string;
}
const DetailPageLayout = ({
  title,
  navRightSection,
  children,
  loading = false,
  backTo,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (backTo) {
      void navigate(backTo);
    } else if (window.history.length > 1) {
      void navigate(-1);
    } else {
      const parentPath = location.pathname.split("/").slice(0, -1).join("/") || "/";
      void navigate(parentPath);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col relative !-m-4 overflow-hidden">
      <div className="w-full min-h-10 flex items-center flex-shrink-0 z-10 p-4 backdrop-blur-md">
        <div className="w-fit flex items-center gap-2">
          <ActionButton
            icon={IconArrowLeft}
            variant={"light"}
            onClick={handleBack}
            size={"md"}
          />
          <Title order={3}>{title}</Title>
        </div>
        {navRightSection && <div className="ml-auto">{navRightSection}</div>}
      </div>
      <div className="w-full flex-1 px-4 min-h-0 overflow-auto">{children}</div>
      <LoadingOverlay
        visible={loading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
    </div>
  );
};

export default DetailPageLayout;
